import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import styled from "@emotion/styled"
import { ThemeProvider } from "emotion-theming"
import themeWW from "../styles/theme-ww"
import Card from "react-bootstrap/Card"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import { css } from "@emotion/core"
import Col from "react-bootstrap/Col"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Container from "react-bootstrap/Container"
import { faCheck } from "@fortawesome/free-solid-svg-icons"

const PricingMentorshipCard = styled(Card)`
  height: 482px;
  position: relative;
  border: ${props =>
    props.isRecommended
      ? "4px solid " + props.theme.colors.primary_violet
      : "2px solid " + props.theme.colors.gray_shadow_card};
  box-shadow: 0px 1px 3px ${props => props.theme.colors.gray_shadow_card};
  @media (max-width: 767px) {
    width: 80vw;
    margin-right: auto;
    margin-left: auto;
    margin-top: 15px;
    &:hover,
    &:focus,
    &.focus,
    &:active,
    &.active {
      margin-top: 10px;
    }
  }
  @media (min-width: 768px) {
    width: ${props => (!props.isSubscription ? `376px` : `278px`)};
    margin-right: 16px;
    margin-top: 0px;
    &:hover,
    &:focus,
    &.focus,
    &:active,
    &.active {
      margin-top: -5px;
    }
  }
`
const CardTitle = styled(Card.Title)`
  margin-bottom: 30px;
  margin-top: 18px;
  font: normal 28px/32px Roboto;
  color: ${props =>
    props.isSubscription
      ? props.theme.colors.primary_violet
      : props.theme.colors.gray_dark};
`

const CardText = styled(Card.Text)`
  margin-bottom: 20px;
`

const PriceTextFont = `
    color: ${props => props.theme.colors.secondary_green10};
    border-bottom: 2px dotted ${props => props.theme.colors.secondary_green10};`

const PriceText = styled.div`
  color: ${props => props.theme.colors.secondary_green10};
  border-bottom: 2px dotted ${props => props.theme.colors.secondary_green10};
  width: fit-content;
  position: absolute;
  margin-top: 10px;
  bottom: 115px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
`

const PriceHeader = styled.div`
  margin-top: 20px;
  margin-bottom: 5px;
  color: ${props => props.theme.colors.gray_light};
  font: normal normal bold 14px/14px Roboto;
`

const PricePackage = styled.div`
  color: ${props => props.theme.colors.gray_dark};
  font: normal normal bold 16px/38px Roboto;
  @media (max-width: 767px) {
    font-size: 14px;
  }
`

const PricePackageIDR = styled.div`
  color: ${props => props.theme.colors.secondary_green10};
  font: normal normal normal 16px/38px Roboto;
  @media (max-width: 767px) {
    font-size: 14px;
  }
`

const ButtonContainer = styled.div`
  position: absolute;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  width: fit-content;
  @media (max-width: 767px) {
    bottom: 0.2px;
  }
  @media (min-width: 768px) {
    bottom: 40px;
  }
`

const ButtonFill = styled(Button)`
  height: 60px;
  color: ${props =>
    props.theme.buttons[
      props.isRecommended
        ? "primary_button_violet"
        : "secondary_big_button_violet"
    ].normal.color} !important;
  background-color: ${props =>
    props.theme.buttons[
      props.isRecommended
        ? "primary_button_violet"
        : "secondary_big_button_violet"
    ].normal.background_color} !important;
  border-color: ${props =>
    props.theme.buttons[
      props.isRecommended
        ? "primary_button_violet"
        : "secondary_big_button_violet"
    ].normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  padding: 0px 20px 0px 20px;
  &:hover {
    color: ${props =>
      props.theme.buttons[
        props.isRecommended
          ? "primary_button_violet"
          : "secondary_big_button_violet"
      ].hovered.color} !important;
    background-color: ${props =>
      props.theme.buttons[
        props.isRecommended
          ? "primary_button_violet"
          : "secondary_big_button_violet"
      ].hovered.background_color} !important;
    border-color: ${props =>
      props.theme.buttons[
        props.isRecommended
          ? "primary_button_violet"
          : "secondary_big_button_violet"
      ].hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media (min-width: 1199px) {
      margin-top: -3px;
      margin-bottom: 3px;
    }
  }
  &:focus,
  &.focus,
  &:active,
  &.active {
    color: ${props =>
      props.theme.buttons[
        props.isRecommended
          ? "primary_button_violet"
          : "secondary_big_button_violet"
      ].pressed.color} !important;
    background-color: ${props =>
      props.theme.buttons[
        props.isRecommended
          ? "primary_button_violet"
          : "secondary_big_button_violet"
      ].pressed.background_color} !important;
    border-color: ${props =>
      props.theme.buttons[
        props.isRecommended
          ? "primary_button_violet"
          : "secondary_big_button_violet"
      ].pressed.border_color} !important;
    box-shadow: none !important;
    @media (min-width: 1199px) {
      margin-top: -3px;
      margin-bottom: 3px;
    }
  }
  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 20px;
    font: 16px/22px Roboto;
  }
`

const FACheck = styled(FontAwesomeIcon)`
  font-size: 1rem;
  color: ${props => props.theme.colors.secondary_green10};
`

const RecommendedButton = styled(Button)`
  width: 180px;
  height: 32px;
  border-radius: 25px;
  background: linear-gradient(
    90deg,
    ${props => props.theme.colors.secondary_green_gradient_light} 0%,
    ${props => props.theme.colors.secondary_green_gradient_dark} 100%
  ) !important;
  font: normal normal bold 14px/14px Roboto;
  text-align: right;
  position: absolute;
  padding-right: 20px;
  top: 25%;
  left: 48%;
`

const CrownCircle = styled(Button)`
  position: absolute;
  left: 0;
  top: 0;
  width: 72px;
  height: 72px;
  border-radius: 72px;
  background-color: white;
  box-shadow: 0px 1px 10px #00000029;
`

const CrownImg = styled.img`
  width: 42px;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const RecommendedContainer = styled(Container)`
  position: absolute;
  width: 250px;
  top: -37px;
  left: 0;
  right: 0;
`

function RecommendedCircle(isRecommended) {
  if (isRecommended) {
    return (
      <RecommendedContainer>
        <div
          css={css`
            position: relative;
            width: 72px;
            height: 72px;
          `}
        >
          <RecommendedButton>RECOMMENDED!</RecommendedButton>
          <CrownCircle />
          <CrownImg
            alt="WomenWorks - crown"
            src="/page-sign-up-for-mentorship-section8-img1.png"
          />
        </div>
      </RecommendedContainer>
    )
  }
}

export default function ThemeMentorshipCards(props) {
  return (
    <ThemeProvider theme={themeWW}>
      <Row css={css``} className="justify-content-center">
        {props.pricing.map((item, i) => (
          <Col
            xs="12"
            md="auto"
            css={css`
              min-height: 525px;
              padding: 0 0 0 0;
              @media (max-width: 767px) {
                padding-top: ${item.isRecommended ? "15px" : "0px"};
              }
            `}
          >
            <PricingMentorshipCard
              isSubscription={item.isSubscription}
              isRecommended={item.isRecommended}
            >
              {RecommendedCircle(item.isRecommended)}

              <Card.Body>
                <CardTitle isSubscription={item.isSubscription}>
                  {item.title}
                </CardTitle>
                <CardText>
                  {item.perks.map(perk => (
                    <Row>
                      <Col
                        xs="auto"
                        css={css`
                          padding-right: 0;
                        `}
                      >
                        <FACheck icon={faCheck} />
                      </Col>
                      <Col
                        css={css`
                          padding-left: 7px;
                        `}
                      >
                        <b>{perk.boldText}</b> {perk.regularText}
                      </Col>
                    </Row>
                  ))}
                  {item.isSubscription ? (
                    <Row>
                      <div
                        css={css`
                          ${PriceTextFont}
                        `}
                      >
                        <PriceText>
                          <span
                            css={css`
                              font-size: 22px;
                              line-height: 32px;
                            `}
                          >
                            {item.price}
                          </span>{" "}
                          per month
                        </PriceText>
                      </div>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs="6">
                        <PriceHeader>
                          Professional
                          <br />
                          experience
                        </PriceHeader>
                        {item.price.map(p => (
                          <PricePackage>
                            {p.name}
                            <br />
                          </PricePackage>
                        ))}
                      </Col>
                      <Col xs="6">
                        <PriceHeader
                          css={css`
                            margin-bottom: 20px;
                          `}
                        >
                          Price per person{" "}
                        </PriceHeader>

                        {item.price.map(p => (
                          <PricePackageIDR>
                            <b>{p.priceBold}</b>
                            {p.priceRegular}
                            <br />
                          </PricePackageIDR>
                        ))}
                      </Col>
                    </Row>
                  )}
                  <ButtonContainer>
                    <OutboundLink
                      target="_blank"
                      rel="noreferrer"
                      href={item.buttonLink}
                    >
                      <ButtonFill isRecommended={item.isRecommended}>
                        {item.buttonText}
                      </ButtonFill>
                    </OutboundLink>
                  </ButtonContainer>
                </CardText>
              </Card.Body>
            </PricingMentorshipCard>
          </Col>
        ))}
      </Row>
    </ThemeProvider>
  )
}
